const emptyDraft = () => ({
  label: '',
  color: '#6b7280',
  zendeskTracking: false,
  vulnTracking: false,
  upgradeTracking: false,
  isActiveSupport: true
})

export { emptyDraft }
